import { Map } from "immutable";
import * as React from "react";
import { Action, IOWidget, mk_widget, unloadedAsyncState, Fun } from "widgets-for-react";
import { Id, CMSState, ImageSize, Url } from "../../../../cms/blocks/types.gen";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";


export type personBlockProps = {
  block_index: number,
  name: string
  role: string
  email?: string
  phone?: string
  image?: Id
  image_alt?: string
}

export type personBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
}>

export function personBlock<customBlockData>(
  props: personBlockProps,
  options?: { style: personBlockStyle; key?: string }
): (s:CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: _ => {
        const imageRes = s.images.get(props.image, unloadedAsyncState())
        const image: Map<ImageSize<ExtraImages>, Url> = imageRes && imageRes.kind == 'loaded' ? imageRes.value : Map()
        return (
          <section className={options && options.style ? options.style.block_classname : ""} key={options.key}>
            <div className={options && options.style ? options.style.inner_classname : ""}>
              <header className={options && options.style ? options.style.header_classname : ""}>
                <h2 className={options && options.style ? options.style.title_classname : ""}>Lorem ipsum dolor sit amet</h2>
              </header>

              <div className={options && options.style ? options.style.content_classname : ""}>
                <aside className="person person--default">
                  <div className="person__inner">
                    <header className="person__header">
                      <span className="person__function label--m">{props.role}</span>
                      <h3 className="person__name title--s">{props.name}</h3>
                    </header>

                    {(props.email || props.phone) && (
                      <div className="person__content">
                        <ul className="person__contact">
                          {props.email && (
                            <li className="ellipsis">
                              <a className="text--s link--default" href={`mailto:${props.email}`}>{props.email}</a>
                            </li>
                          )}

                          {props.phone && (
                            <li>
                              <a className="text--s link--default" href={`tel:${props.phone}`}>{props.phone}</a>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="person__visual">
                    {imageRes.kind == 'loaded' && (
                      <img className="person__image lazyload" height="208" width="208" alt=""
                            src='/frontend/images/empty.gif'
                            data-src={image.get('medium')}
                            data-srcset={"..."}
                            data-sizes="208px" />
                    )}
                  </div>
                </aside>
              </div>
            </div>
          </section>
        )
      },
    })
}
